export const THEME_COLOR = "#7338FF";

export const RUSD_FEATURES = [
  "持续收益，稳定运行",
  "团队合作，共享收益",
  "基于协议的奖励分配",
];

export const PROMOTION_ITEMS = [
  {
    icon: require("@/assets/image/tglm.png"),
    title: "推广联盟",
    desc: "层级奖励，团队奖励，业绩奖励，卡牌奖励",
  },
  {
    icon: require("@/assets/image/nftds.png"),
    title: "NFT大使",
    desc: "绩效奖励，代币赠送，全网分红，多节点奖励",
  },
];

export const ROADMAP_ITEMS = [
  {
    date: "6月",
    title: "新加坡基金会重启RAD生态",
    desc: "将底池逐步建立到500万枚BOX",
  },
  {
    date: "6月",
    title: "AI超级算法链上哈希策略全球公测",
    desc: "预计将获得基金会500-1000万美金支持",
  },
  {
    date: "7月",
    title: "第1批合伙人节点",
    desc: "(金卡、银卡、铜卡)拆盲盒抢购",
    titleHighlight: true,
  },
  {
    date: "8月",
    title: "上线质押生态挖RUSD稳定币",
    desc: "联动Debox稳定币",
  },
  {
    date: "2027",
    quarter: "1季度",
    title: "上线增值稳定币DEFI生态",
    desc: "含第2批卡牌拆盲盒",
  },
  {
    date: "2027",
    quarter: "2季度",
    title: "上线中心化交易所",
    desc: "币安 欧意等",
  },
  {
    date: "2027",
    quarter: "3季度",
    title: "上线链上游戏生态",
    desc: "含第3批卡牌拆盲盒",
  },
  {
    date: "2027",
    quarter: "4季度",
    title: "上线链上商城生态",
    desc: "含第4批卡牌拆盲盒",
  },
  {
    date: "未来",
    title: "币股同权在美国纳斯达克上市",
    desc: "",
    future: true,
  },
];

export const PARTNERS_LIST = Array.from({ length: 12 }, (_, i) => ({
  id: i + 1,
  image: require(`@/assets/image/partner${i + 1}.png`),
}));
